//@getters
import { GetterTree } from 'vuex'
import { ticketState } from './state'

export const getters: GetterTree<any, ticketState> = {
}
